// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"a21f2554","107":"c0d993d5","633":"460f24d1","711":"51dc3e97","953":"a4ead3c7"}[chunkId] + ".chunk.js";
};